import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/redux';

export enum PageTabsKeyEnum {
  PROJECTS = 'projects',
  PROJECT_DETAILS = 'projectDetails',
  DATA_CATALOG = 'dataCatalog',
  DATASET_DETAILS = 'datasetDetails',
}

export type PageTabValue = string | number;

type PageTabsModel = Partial<Record<PageTabsKeyEnum, PageTabValue>>;

const pageTabsSlice = createSlice({
  name: 'pageTabs',
  initialState: {} as PageTabsModel,
  reducers: {
    setPageTab: (state, { payload }: PayloadAction<{ page: PageTabsKeyEnum; tab: PageTabValue }>) => {
      state[payload.page] = payload.tab;
    },
  },
});

export const selectPageTab =
  (page: PageTabsKeyEnum) =>
  (state: RootState): PageTabValue | undefined =>
    state.pageTabs[page];

export const { setPageTab } = pageTabsSlice.actions;
export default pageTabsSlice.reducer;
